import '@rainbow-me/rainbowkit/styles.css';
import { WagmiProvider } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit';
import { wagmiConfig } from '../config/wagmi';

/**
 * Web3 wallet context — scoped to the sweep page only (wallet connection is
 * not needed anywhere else in the admin panel).
 *
 * The app's root QueryClientProvider (index.jsx) is an ancestor of this, so
 * wagmi's react-query hooks resolve correctly.
 */
export default function Web3Provider({ children }) {
  return (
    <WagmiProvider config={wagmiConfig}>
      <RainbowKitProvider
        theme={darkTheme({
          accentColor: '#0ac785',
          accentColorForeground: '#04140d',
          borderRadius: 'medium',
        })}
        initialChain={bsc}
      >
        {children}
      </RainbowKitProvider>
    </WagmiProvider>
  );
}
